import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PhoneIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="currentColor"
    title={t`Phone`}
    accessible={false}
    {...props}
  >
    <Path
      fill="#001A19"
      d="M5.016 1.251a1.957 1.957 0 0 1 1.949 1.68v.006c.07.522.198 1.035.383 1.528h-.001a1.952 1.952 0 0 1-.44 2.061l-.004.003-.347.346a8.893 8.893 0 0 0 2.558 2.554l.35-.349.003-.003a1.957 1.957 0 0 1 2.06-.44h.001c.371.139.753.245 1.14.319l.392.063h.006a1.952 1.952 0 0 1 1.683 1.965h.001v1.804l-.01.203a1.95 1.95 0 0 1-1.321 1.657 1.96 1.96 0 0 1-.802.094h-.014a12.706 12.706 0 0 1-5.528-1.963 12.504 12.504 0 0 1-3.85-3.842v-.001a12.651 12.651 0 0 1-1.966-5.543l-.001-.012-.008-.203A1.953 1.953 0 0 1 3.205 1.25h1.81v.001ZM3.112 2.76a.461.461 0 0 0-.339.3.452.452 0 0 0-.021.181c.186 1.741.78 3.414 1.734 4.884l.004.006a11.003 11.003 0 0 0 3.389 3.382l.006.004a11.206 11.206 0 0 0 4.872 1.73.458.458 0 0 0 .455-.27.455.455 0 0 0 .038-.183v-1.828l-.006-.083a.453.453 0 0 0-.387-.378v-.001a8.509 8.509 0 0 1-1.398-.306l-.454-.155h-.002a.46.46 0 0 0-.482.103l-.764.761-.095.08a.75.75 0 0 1-.806.041 10.394 10.394 0 0 1-3.9-3.893.75.75 0 0 1 .121-.903l.767-.764a.454.454 0 0 0 .098-.476V4.99l-.155-.453a8.47 8.47 0 0 1-.308-1.396.454.454 0 0 0-.456-.391H3.206l-.094.01Z"
    />
  </Icon>
);
